import React from 'react';
import moment from 'moment';
import { Row, Col } from 'antd';

import { Title } from '@/components/Typography';
import { Field } from './Field';
import { ReportInformation } from './types';
import * as S from './styles';

interface InformationsProps {
	data: ReportInformation;
}

export function Informations({ data }: Readonly<InformationsProps>) {
	return (
		<Row gutter={[0, 10]}>
			<Col span={24}>
				<Title level={3}>Informations</Title>
			</Col>
			<Col span={24}>
				<S.Content justify="space-between">
					<Col span={12}>
						<Row gutter={[0, 8]}>
							<Field label="Company" value={data.organization_name} />
							<Field label="Industrial site" value={data.company_name} />
							<Field label="Sector" value={data.sector_name} />
							<Field label="Line" value={data.line_name} />
							<Field label="Workstation" value={data.workstation_name} />
							<Field label="Activity" value={data.activity_name} />
						</Row>
					</Col>
					<Col span={1}>
						<S.CustomDivider type="vertical" />
					</Col>
					<Col xs={10} xxl={{ span: 10, offset: 1 }}>
						<Row gutter={[0, 8]}>
							<Field label="Report name" value={data.report_name} />
							<Field label="File" value={data.file_name} />
							<Field label="Collection date" value={moment(data.collection_date).format('L')} />
							<Field label="Assessment date" value={moment(data.assessment_date).format('L')} />
							<Field label="Evaluator" value={data.evaluator_name} />
						</Row>
					</Col>
				</S.Content>
			</Col>
		</Row>
	);
}
